import { render, staticRenderFns } from "./template.html?vue&type=template&id=1d758ba8&scoped=true&external"
import script from "./DetailPhotos.vue?vue&type=script&lang=js"
export * from "./DetailPhotos.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=1d758ba8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d758ba8",
  null
  
)

export default component.exports